// let constants = {
//    // apiServiceBaseUri: 'http://zona572.com/~hoyostools/admin/frontend/web/index.php'
//    apiServiceBaseUri: 'http://zona572.com/~pallomaro/B2Bstandard/admin/frontend/web/index.php',
//    apiServiceBaseUri2: 'http://zona572.com/~pallomaro/B2Bstandard/admin/backend/web/index.php',
//    config: {leer
//       appName: 'Hoyostools',
//       appVersion: 1.0,
//       home_url: '/app/home',
//       env: {
//          basePath: 'http://zona572.com/~pallomaro/',
//          frontPath: 'http://zona572.com/~pallomaro/',
//          apiEndPoint: 'http://zona572.com/~pallomaro/B2Bstandard/admin/frontend/web/index.php'
//       },



let path =  window.location;


let constants = {
    // apiServiceBaseUri: 'http://zona572.com/~hoyostools/admin/frontend/web/index.php'
    // apiServiceServerBase:'http://98.142.96.50/~hercules/admin/frontend/web/index.php',//ur que se agrega si el front pertenese a e-solutions
    apiServiceBaseUri: __env.envApiServiceBaseUri,
    apiServiceBaseUri2: __env.envApiServiceBaseUri2,
    env:__env,
    config: {
        appName: 'Hoyostools',
        appVersion: 1.0,
        home_url: 'landing',
        env: {
            // basePath: 'http://98.142.96.50/~hercules/',
            basePath: path.origin+path.pathname,
            base:path.origin,
            frontPath: 'http://98.142.96.50/~hercules/',
            apiEndPoint: 'http://98.142.96.50/~hercules/admin/frontend/web/index.php',
            imagePath: path.origin+path.pathname
        },
        captchaKey: __env.captchaKey,
        paths: {
            categoriesMenu: '/param/get-category-menu',
            categories: '/categoria-info/ver-categorias',
            category: '/categoria-info/ver-categoria?id=',
            categoryArbol: '/categoria-info/arbol-categoria?id=',
            categoryProducts: '/categoria-info/ver-productos-categoria?id=',
            categoryAttributes: '/categoria-info/ver-atributos-categoria-dos?id=',
            advancedAttributes: '/item-info/get-advanced-attributes',
            compoundAttributes: '/item-info/get-compounds-attributes?id=',
            productsByAdvancedSearch: '/item-info/products-by-advanced-search',
            featuredProducts: '/item-info/ver-productos-destacados',
            product: '/item-info/ver-producto?id=',
            compareProducts: '/item-info/comparar-productos?ids=',
            setCoverageDelivery:'/location/set-coverage-delivery',

            // relatedProducts: '/item-info/ver-productos-relacionados?id=',
            relatedProducts: '/item-info/ver-productos?type=relacionados&itemId=',
            relatedCategoryProducts: '/item-info/ver-productos?type=relacionados_categoria&itemId=',

            searchProduct: '/item-info/buscar-producto?cadena=',
            searchProductAutocomplete: '/item-info/autocompletado-producto?cadena=',
            searchProductLength: '/item-info/buscar-producto-cantidad?cadena=',
            adavancedSearchProduct: '/item-info/busqieda-avanzada-producto',
            clonedProductPrice: '/item-info/obtener-precio-item-clonado',
            setFavoriteProduct: '/item-info/set-favorite-product',
            getProductComments: '/items/items/get-calificaciones?item_id=',

            setProductComment: '/items/items/set-calificacion',
            setTestimony: '/items/items/set-testimonio',
            getTestimony: '/items/items/get-testimonios?item_id=',

            //procedures
            procedureFeatures: '/item-info/caracteristicas-item?itemId=',
            getProcedures: '/item-info/get-procedures-data',

            //events
            getEvent: '/evento/get-eventos',
            getEvents: '/evento/event-list',

            //testimonies
            testimonies: '/item-info/testimonios-item?itemId=',

            //box text
            getBoxText: '/param/get-contenido-cms?component_name=',

            // Fast Search
            //fastSearchFavoriteItems: '/item-info/get-favorite-items',
            fastSearchFavoriteItems: '/item-info/ver-productos?type=favoritos',
            fastSearchResumeFavoriteItems: '/item-info/get-resume-favorites',
            fastSearchLastItemsBought: '/item-info/get-last-items-bought',
            fastSearchBranchsUsert: '/location/get-location-by-search-text',
            fastSearchOperatingCentersByUser: '/login/get-operating-centes-by-user-by-search-text',

            newItems: '/item-info/get-new-items',
            boxItems: '/item-info/ver-productos',
            bestSellerItems: '/item-info/ver-productos-mas-vendidos',
            salesItems: '/item-info/lista-items-en-oferta',
            salesItemsLength: '/item-info/total-items-en-oferta',
            categoryFeatured: '/categoria-info/get-categorias-destacadas',

            // Location Paths
            countries: '/location/get-countries',
            states: '/location/get-states?countryId=',
            cities: '/location/get-cities?stateId=',
            location: '/location/get-location?ids=',
            locationBySearchText: '/location/get-location-by-search-text',
            locationRuler :'/location/get-ruler-location',

            // Mails
            mailContact: '/item-info/enviar-correo-contactenos',
            mailProductNotFound: '/item-info/enviar-correo-producto-no-encontrado',
            mailProductRecommended: '/item-info/enviar-correo-producto-recomendado',

            mailNewsletter: '/item-info/send-newsletter-register',

            getRegisterMessage: '/login/get-messages-of-register',

            // User
            recoverPassword: '/login/recover-password',
            userLogin: '/login/user-login',
            userLogout: '/login/user-logout',
            userRegister: '/login/user-register',
            validateEmail: '/login/validate-email',
            validateNumberId: '/login/validate-number-id',
            userUpdate: '/user/update-user',
            passwordUpdate: '/user/update-password',
            getUserInfo: '/user/user-info',
            thirdBySearchText: '/user/get-third-by-search-text',
            getGenero: '/login/get-genero',
            getTiposDocumentos: '/user/get-tipo-documentos',
            getActividadEconomica: '/login/get-actividad-economica',
            validateUserName: '/login/validate-user-name',

            // Contact
            getContactByIdentificationNumber: '/user/get-contact-by-identification-number',

            // Carrito
            addItemToCart: '/cart/agregar-item-canasta',
            getCart: '/cart/obtener-canasta?cartId=',
            deleteCart: '/cart/delete-cart',
            deleteItemFromCart: '/cart/eliminar-item-canasta',
            updateCommentCart: '/cart/update-comment-cart',
            updateCommentItemCart: '/cart/update-comment-item-cart',
            updateQuantityItemCart: '/cart/update-quantity-item-cart',
            saveCartOrderData: '/cart/save-cart-order-data',
            saveCartTunnelData: '/cart/save-cart-tunnel-data',
            getPointsOfSale: '/cart/points-of-sale',
            updateCityLocation: '/cart/update-city-location',
            updatePayMethod: '/cart/update-pay-method',
            updateDespachoPedido: '/cart/update-despacho-pedido',
            getResumeCart: '/cart/get-cart-resume-data',
            getQuantitiesBasket: '/cart/get-qunatities-basket-b2b',
            updatePayCondition: '/cart/update-pay-condition',
            updatePayConditionAuto: '/cart/cambio-automatico-condicion-pago',
            checkItemsPriceByCart: '/cart/check-items-price-by-cart',

            //directions
            getAllDirections: '/centroOperaciones/centro-operaciones/get-direcciones',
            getDirection: '/centroOperaciones/centro-operaciones/get-direccion',
            saveDirection: '/centroOperaciones/centro-operaciones/create',
            editDirection: '/centroOperaciones/centro-operaciones/update',
            deleteDirection: '/centroOperaciones/centro-operaciones/delete',

            // Order
            payMethods: '/order/pay-methods',
            payMethod: '/order/pay-method?payMethodId=',
            payConditions: '/order/pay-coditions',
            payConditionsChangeBranchOffice: '/order/pay-conditions-change-branch-oficce',
            saveOrder: '/order/save-order',
            getOrder: '/order/order',
            duplicateOrder: '/cart/duplicate-order',
            getPay: '/order/get-pay-info?idPedido=',
            getUserOrders: '/order/user-orders',
            getDashboardInfo: '/dashboard/dashboard-info',
            createCartTemplate: '/cart/create-cart-template',
            getUserCartTemplates: '/cart/get-cart-templates',
            getUserCartTemplate: '/cart/get-cart-template',
            duplicateCartTemplate: '/cart/duplicate-cart-template',
            duplicateCartTemplateWithStock: '/cart/duplicate-cart-template-with-stocks',
            deleteCartTemplate: '/cart/delete-cart-template',
            changeStatus: '/order/change-status',
            sincronizarPedido: '/order/sincronizar-erp',
            validateMinimumQuantity: '/order/validate-minimum-quantity',

            recalcularPedido: '/order/recalcular-valor-orden?orderId=',

            experienceComment: '/order/qualify-shopping-experience',
            getTracking:'/transport/tracking',

            // Quotes
            updateOrder: '/order/update-order',
            replyQuotes: '/quotes/reply-order',
            sendCopyEmailOrder: '/order/send-copy-order',
            convertOrder: '/quotes/convert-order',
            getSummaryQuotes: '/quotes/summary-quotes',
            loadPricesForPriceList: '/quotes/load-prices-for-price-list',
            setLostQuote: '/quotes/set-lost-quote',
            // Enlistment
            createEnlistment: '/enlistment/create-enlistment',
            // Warranty
            searchWarranty: '/warranty/search-warranty',
            saveWarranty: '/warranty/save-warranty',
            // Banners
            getBanners: '/template/get-ads-info',

            getCMSBanners: '/template/cms-seo',
            getCMS: '/template/cms-spaces',

            // App params
            getParams: '/param/get-app-params',
            getParamsRegistroConductores: '/param/get-params-registro-conductores',
            // Contact Locations
            getContactLocations: '/location/get-contact-locations',

            // Seller Client
            getSellerClients: '/login/get-seller-clients',
            getSellerClientThirds: '/login/get-client-thirds',
            getSellerClientOperatingCenters: '/login/get-client-operating-centers',
            setClientOperatingCenter: '/login/set-client-operating-center',
            getOperatingCentersByUser: '/login/get-operating-centes-by-user',

            // Edarvico: Busqueda de motobombas
            getUmCaudalPresion: '/item-curva/get-unidades-medida',
            getMotobombas: '/item-curva/buscar-items',
            getCategoriasBombas: '/item-curva/get-categorias-bombas',

            // Ocasional Client
            getOcasionalInformation: '/user/get-ocasional-information',
            updateInfoClientSelected: '/user/update-info-client-selected',
            createUserByAdmin: '/user-admin/create-update-user-by-admin',
            usersRelatedToAdmin: '/user-admin/users-related-to-admin',
            sendInvitationToRealtedAdmin: '/user-admin/send-invitation',
            enableUserAdmin: '/user-admin/enable-user-admin',
            permissionsFront: '/user-admin/get-permissions-front',
            preloadUserCreatedByAdmin: '/user-admin/preload-user-created-by-admin',
            getSummaryMasterUser: '/user-admin/get-summary-master-user',

            //initialsParams

            getUrlInitialsParams : '/adminComponentes/companies/get-companie-url-base',

            // Consult
            getConsult: '/consult/get-consult',
            orderStatusReport: '/sincronizaciones/reportes-b-2-b/pedido-importado',
            referralsOrdersReport: '/sincronizaciones/reportes-b-2-b/remision-importada',

            // Consult
            getSucursales: '/login/get-sucursales-id-usuario',

            // Habilitar Sucursal Principal
            paramSucursalPrincipal: '/param/get-uso-sucursal-principal',

            // Obtener sucursales principales
            getSucursalesPrincipales: '/param/get-sucursales-principales/',

            // Obtener modalidd de envio
            getModalidadEnvio: '/cart/obtener-modalidad-envio',

            // Obtener sucursal secundari
            getSucursalesSecundarias: '/param/get-sucursales-secundarias/',

            // Limpiar Fecha Entrega
            updateDateCart: '/cart/cambiar-fecha-pedido/',

            // Cambiar promesa de entreag
            updatePromiseCart: '/cart/cambiar-promesa-entrega',

            // Cambiar modalidad de pago
            updatePaymentMethod: '/cart/cambiar-modalidad-pago',


            // Cambiar promesa de entreag
            getCanastaConductores: '/cart/get-canasta-conductores',

            // grabar conductor de la canasta
            saveCartDriver: '/cart/save-cart-driver',


            getPedidoConductores:'/order/get-pedido-conductores',
            saveOrderDriver:'/order/save-order-driver',


            // Obtener modalidades de entrega
            getModalidadesEntrega: '/param/modalidades-entrega',

            // Obtener modalidades de entrega
            verificarBloqueoRetiroSucursal: '/cart/verificar-bloqueo-retiro-sucursal',

            // Actaualizar servicio descargue
            servicioDescargue: '/cart/actualizar-servicio-descargue',

            // Actualizar servicio propio
            transportePropio: '/cart/actualizar-transporte-propio',

            // Actuzliar Servicio Ultracem
            transporteUltracem: '/cart/actualizar-transporte-ultracem',

            // Actuzliar Modalidad Envio
            updateShippingMode: '/cart/actualizar-modalidad-envio',

            // Obtener la promesa de entrega
            getPromiseDelivery: '/cart/obtener-promesa-entrega',

            // Validar Dia Feriado
            validateHoliday: '/cart/verificar-compra-dias-festivos',

            // Verificar tipo de modalidad de envio
            checkTypeOfShippingMode: '/param/verificar-tipo-de-modalidad',

            // Verificar bloqueo servicio de descargue
            verifyUnloadingService: '/cart/verificar-servicio-descargue-modal/',

            // Verificar mora antes de realizar el pago
            checkDefaultPaymentOrders: '/order/verificar-mora-tercero-pago',

            // Crear token por usuario
            createToken: '/login/user-create-token',

            // Verificar reglas
            verificarRegla: '/cart/verifica-regla-volumen-compra',

            // Verificar reglas
            assignWarehouseBasketCode: '/cart/asignar-codigo-bodega-canasta',

            // Verificar servicio descargue bodega
            verifyServiceDownloadWarehouse: '/cart/verificar-servicio-descargue-bodega',

            // Verificar Volumen Compra login
            verificarVolumenCompraCanasta: '/cart/verificar-volumen-compra-canasta',

            verifyDaysFestivesBranchOfficePromise: '/cart/verificar-dias-festivos-sucursal-promesa',

            getMaximumMainVolume: '/cart/obtener-volumen-maximo-principal',

            PROVIDER: {
                SCHEDULED_PAYMENTS: 'proveedores/pagos-programados/listar',
                FINISHED_PAYMENTS: 'proveedores/pagos-realizados/listar',
                CREDIT_NOTES: 'proveedores/notas-credito/listar',
            },
            PQRS: {
                PARAMS: '/pqrs/get-params',
                SAVE: '/pqrs/save-pqrs',
                LIST: '/pqrs/get-pqrs-list',
                DETAIL: '/pqrs/get-pqrs-detail',
                SAVE_RESPONSE: '/pqrs/save-pqrs-response',
                RESOLVED: '/pqrs/resolve-pqrs',
                CHANGE_STATUS: '/pqrs/change-status',
                RESPONSABLES_LIST: '/pqrs/get-responsable-pqrs-list?search=',
                CHANGE_PQRS_RESPONSABLE: '/pqrs/change-responsable-pqrs',
                EXPORT_CSV: '/pqrs/exportar-incidencias-listado-csv',
                EXPORT_CSV_DETAIL: '/pqrs/exportar-incidencia-csv'
            },
            REPORTS: {
                // SYNC: {
                //   ORDER: {
                //     STATES: '/sincronizaciones/reportes-b-2-b/pedido-importado'
                //   },
                //   REMISSION: {
                //     LIST: '/sincronizaciones/reportes-b-2-b/remision-importada'
                //   }
                // },
                SYNC: {
                    ORDER: {
                        STATES: '/sincronizaciones/reportes-b-2-b/pedido-importado',
                        STATES2: '/sincronizaciones/reportes-b-2-b/pedidos-importado-sucursal',
                        EXPORTEXCEL: '/sincronizaciones/reportes-b-2-b/pedidos-exportar-excel'
                    },
                    REMISSION: {
                        LIST: '/sincronizaciones/reportes-b-2-b/remision-importada',
                        LIST2: "/sincronizaciones/reportes-b-2-b/remision-importadas-local",
                        EXPORTEXCEL: '/sincronizaciones/reportes-b-2-b/remision-exportar-excel'
                    },
                    BILLFOLD: {
                        LIST: "/sincronizaciones/reportes-b-2-b/cartera-importada",
                        LIST2: "/sincronizaciones/reportes-b-2-b/carteras-importadas-sucursal",
                        EXPORTEXCEL: '/consult-agp/carteras-exportar-excel',
                        EXPORT_PDF: "/consult-agp/carteras-exportar-pdf" ,
                    },
                    BILLFOLD_CLIENT: {
                        LIST: "/consult-agp/consulta-cuentas-x-cobrar",
                        EXPORTEXCEL: '/sincronizaciones/reportes-b-2-b/carteras-exportar-excel'
                    },
                    PENDIENTES_ITEMS: {
                        LIST: "/sincronizaciones/reportes-b-2-b/pendientes-items-online",
                        //LIST2: "/sincronizaciones/reportes-b-2-b/carteras-importadas-sucursal",
                        EXPORTEXCEL: '/sincronizaciones/reportes-b-2-b/pendientes-items-online-exportar-excel',
                        EXPORT_PDF: "/sincronizaciones/reportes-b-2-b/pendientes-items-online-exportar-pdf"
                    },
                    PAYMENT_HISTORY: {
                        LIST: "/consult-agp/consulta-historico-pagos",
                        DETAIL: "/consult-agp/consulta-recibo-caja-detalle",
                        EXPORT_EXCEL: "/consult-agp/consulta-historico-pagos-exportar-excel" ,
                        EXPORT_PDF: "/consult-agp/consulta-historico-pagos-exportar-pdf" ,
                        EXPORTDETAIL_EXCEL: "/consult-agp/consulta-recibo-caja-detalle-exportar-excel",
                        EXPORTDETAIL_PDF: "/consult-agp/consulta-recibo-caja-detalle-exportar-pdf" 
                    }
                },
                B2B: {
                    CLIENT: "/sincronizaciones/reportes-b-2-b/cliente",
                    ORDERS: "/sincronizaciones/reportes-b-2-b/pedidos-cliente",
                    CONSOLIDATED: "/sincronizaciones/reportes-b-2-b/consolidados-cliente", // TODO: DELETE
                    //BILLFOLD_RESUME: "/sincronizaciones/reportes-b-2-b/cartera-cliente", // TODO: DELETE
                    CONSOLIDATED_SMARTB: "/sincronizaciones/reportes-b-2-b/consolidados-cliente-smart-b",
                    // BILLFOLD_RESUME: "/sincronizaciones/reportes-b-2-b/cartera-cliente",
                    BILLFOLD_RESUME: "/sincronizaciones/reportes-b-2-b/reporte-cartera-cliente"
                }
            },
            WALLET:{
                DEBTS_TO_PAY: "/consult-agp/consulta-analisis-cliente",
            },
            PRODUCTS: {
                LAST_ITEMS_BOUGHT: '/item-info/get-last-items-bought'
            }
        }
    },
    site: {
        config: {
            // Bandera para depuración del sitio. Muestra cierta información como
            // liquidación de transporte, etc.
            debug: false,
            showLegalAdvice: false,
            redirectToB2bPage: false,
            quantity_validate: false,
            data: {
                item: {
                    // Muestra los comentarios en la canasta
                    showComments: false,
                    // Habilitación del filtro de precios en el listado de productos de unsa categoría
                    showItemsPriceFilter: true,
                    // Texto utilizado para el 'Precio en Internet'
                    internetPriceString: 'Precio',
                    // Titulo para anexos de producto
                    annexedDocumentString: 'Ficha Técnica',
                    // No se utiliza
                    getMoreSelledProducts: false,
                    // No se utiliza
                    getNewProducts: false,
                    // No se utiliza
                    getJoyasDeLaCasaProducts: false,
                    // No se utiliza
                    placeholderSearchProduct: ''
                },
                shipping: {
                    // Habilita la búsqueda rápida. No utilizar.
                    fastSearch: true,
                    // Muestra el punto de venta en la canasta.
                    showPointsOfSale: false,
                    // Muestra la forma de entrega en la canasta
                    showShippingMethod: false,
                    // Muestra el banner de entrega en la canasta. Este se debe utilizar cuando
                    // se ocultan los dos parámetros: showPointsOfSale, showShippingMethod
                    showBannerShippingMethod: true
                },
                cart: {
                    cartBuyText: 'Confirmar pedido',
                    // Mostrar comentario de la orden
                    showOrderComment: true,
                    maxlengthOrderComment: 60,
                    // Mostrar simulación de cupon
                    showDiscountCoupon: false,
                    // Mostrar precio de transporte
                    showTransportPrice: true,
                    // mostrar boton de pdf
                    showPdfButton: false,
                    // mostrar mensaje 'TENER PRESENTE'
                    showPremessageOrder: false,
                    showSelectPriceList: false,
                    showFooterCartBanner: false,
                    showCartetera: false
                },
                tunnel: {
                    // Mostrar fecha programada de entrega
                    showContactProgrammedDelivery: true,
                    // Utilizar pasarela
                    hasGangway: true,
                    // Permite realizar cotizaciones sin estar logueado
                    allowQuotesNoLogin: true
                },
                banners: {
                    // Mostrar banners de noticias. Essto fue una prueba.
                    showNews: false
                },
                categories: {
                    // Tipos de Menu:
                    // 1. Con campo de filtro
                    // 2. Slider a 2 niveles
                    // 3. Slider multinivel
                    menuType: 2,
                    // Comentario de categoria
                    textOurProducts: "Lorem ipsum dolor sit amet consectetur adipisicing elit. A sequi ad vel officia. Similique beatae in qui sit."
                },
                cartera: {
                    carteraPorSucursal: false
                },
                register: {
                    // Login automático o no
                    automaticLogin: true,
                    // permitir registro
                    allowRegister: true
                }
            },
            header: {
                // mostrar menu (Inicio,productos,categorias,ofertas,etc...)
                showIcons: true,
                // mostrar opcion de mi cuenta
                show_account_in_header: true,
                // seleccionar sucursal
                selectBranch: true,
                // mostrar carrito
                show_cart_in_header: true,
                // mostrar categorias
                showCategories: true,
                // mostrar quienes somos
                showKnowUs: true,
                // mostrar ofertas
                showOfferts: true,
                // mostrar contactenos
                showContact: true,
                // mostrar menu lateral
                show_tab_right: false,

                pay_zone: {
                    // mostrar pagos y anticipos
                    pay_zone_and_advances: false,
                    // mostrar zona de pago
                    only_pay_zone: true,
                    // no se utiliza
                    only_advances: false,
                    // mostrar mis pagos
                    only_payments: false
                },
                logout: {
                    // redirigir al perder sesion
                    state_lost_session: 'home.login'
                },
                fastLoad: {
                    // mostrar compra rapida
                    showFastLoad: true
                }
            },
            pay_zone: {
                // url para home
                home_url: 'home.detailZone',
                // url para zona de paog
                payments_url: 'home.myPaymentsList'
            },
            login: {
                // texto de bienvenida sin surcusal
                text_welcome_withow_branch: 'Los datos de acceso son correctos, bienvenido a nuestra tienda virtual.',
                // texto de bienvenida con surcusal
                text_welcome_with_branch: 'Las credenciales de acceso son validas. Seleccione la sucursal con la que desea realizar las compras.'
            },
            // Panel de control del usuario
            dashboard: {
                // Mostrar resumen de las operaciones del usuario o un banner publicitario
                showSummary: false,
                // Mostrar las ordenes
                showMyOrders: true,
                // Mostrar las cotizaciones
                showMyQuotes: true,
                // Mostrar ver mi cuenta. Aquí se realiza la actualización de los datos.
                showMyAccount: true,
                // Mostrar cliente seleccionado. Dejar en 'false'.
                showSelectClient: true
            },
            menu: {
                // Mostrar menu de Incidencias
                showPqrs: true,
                // Mostrar menu de consultas B2B
                showConsults: true,
                // Mostrar menu corporativo
                showCoorporateDemoMenu: false,
                // mostrar enlace de búsqueda de trabajo
                showSearchJob: false,
                // Mostrar búsqueda dentro del menu
                showSearchInsideMenu: true,
                // Mostrar enlace de búsqueda rápida en el menu del footer. Si
                // se deja en 'true' el enalce se muestra en el menu del header.
                showFastLoadInHeader: true,
                // no se utiliza
                showFastLoadInFooter: true,
                // no se utiliza
                showFastLoadAlways: false,
                // no se utiliza
                fastLoadText: 'Carga rápida'
            }
        },
        app: {
            clientName: 'pallomaro',
            url: 'http://ferreteriaonlinehoyostools.com/',
            title: 'Pallomaro',
            description: 'Tienda Virtual Pallomaro - Equipos para negocios de alimentos',
            header: {
                showContactInfo: true,
                placeholder: 'Buscar',
                logo: {
                    src: './assets/img/proyect-selected/logo-header.png',
                    url: 'home.home',
                    url_url: 'home',
                    // url: 'http://ferreteriaonlinehoyostools.com/#/',
                    title: 'Pallomaro',
                    alt: 'Pallomaro',
                    width: '210px',
                    height: 'auto'
                }
            },
            pages: {
                corporate: {
                    link: {
                        url: 'home.knowUs',
                        title: 'Pallomaro'
                    }
                }
            },
            footer: {
                menu: {
                    contactUrl: 'home.contact'
                },
                info: {
                    title: 'Tienda Virtual Pallomaro - Equipos para negocios de alimentos',
                    description: 'Nuestras soluciones y proyectos rentabilizan significativamente los procesos empresariales con la creación de nuevos canales de ventas, servicios y modelos de negocio.',
                    date: new Date()
                },
                logo: {
                    src: './assets/img/proyect-selected/logo-footer.png',
                    title: 'Smart4B',
                    alt: 'Smart4B',
                    width: '200px',
                    height: 'auto'
                },
                showNewsletterForm: false
            },
        },
        info: {
            company: {
                name: 'Smart4B',
                nit: '',
                webpage: '',
                address: 'Carrera 4 #21-40',
                pbx: '(57 2) 485 5511',
                phone: ' (57 2) 485 5511',
                cell: '',
                email: 'info@pallomaro.com',
                location: 'Cali - Colombia'
            },
            style: {
                mainColor: 'rgb(245, 134, 52)',
                secondColor: 'rgb(255, 222, 0)'
            },
            social: {
                facebook: {
                    title: 'Síguenos en facebook',
                    link: 'https://www.facebook.com/valoramoslaalimentacion/',
                    alt: 'Facebook',
                    show: true
                },
                youtube: {
                    title: 'Véanos en youtube',
                    link: 'https://www.youtube.com/user/6136465?sub_confirmation=1',
                    alt: 'Youtube',
                    show: true
                },
                twitter: {
                    title: 'Twitter Pallomaro',
                    link: 'https://twitter.com/pallomaro',
                    alt: 'Twitter',
                    show: true
                },
                pinterest: {
                    title: 'Pinterest Pallomaro',
                    link: 'https://co.pinterest.com/pallomaro/',
                    alt: 'Pinterest',
                    show: true
                },
                linkedin: {
                    title: 'Linkedin Pallomaro',
                    link: 'https://twitter.com/pallomaro',
                    alt: 'Twitter',
                    show: true
                },
                instagram: {
                    title: 'Instagram Pallomaro',
                    link: 'https://www.instagram.com/pallomaro/',
                    alt: 'Instagram',
                    show: true
                }
            },
            /*
             video: {
             link: 'https://www.youtube.com/embed/hq7ZrUQN1ZY'
             },
             imagenvideo: {
             idvideo: 'http://img.youtube.com/vi/hq7ZrUQN1ZY/0.jpg'
             },
             */
            recaptcha: {
                id: '6LfbIwsTAAAAAKhEWIKXphwD_Qa26r0_xl5E0Yon'
            }
        }
    }
};

export default constants;



/** WEBPACK FOOTER **
 ** ./www/components/app.constants.js
 **/